import { configureStore } from "@reduxjs/toolkit";
import homeSlice from "./homeSlice";
import productsSlice from "./productsSlice";
import wishlistSlice from "./wishlistSlice";
import userSlice from "./userSlice"
import loginSlice from "./loginSlice";
import cartSlice from "./cartSlice";
import couponSlice from "./couponSlice";
import  orderSlice  from "./orderSlice";
import authModelSlice from './authModelSlice'

export const store = configureStore({
    reducer: {
        login: loginSlice,
        user: userSlice,
        appearances: homeSlice,
        products: productsSlice,
        wishlist: wishlistSlice,
        carts: cartSlice,
        coupons:couponSlice,
        orders:orderSlice,
        model:authModelSlice
    }
})